import clsx from "clsx";

const colorClasses = {
  blue: "bg-blue-200 hover:bg-blue-300",
  gray: "bg-gray-200 hover:bg-gray-300",
  green: "bg-green-200 hover:bg-green-300",
  red: "bg-red-200 hover:bg-red-300",
  yellow: "bg-yellow-200 hover:bg-yellow-300",
  purple: "bg-purple-200 hover:bg-purple-300",
  outlineGreen: `bg-emerald-100 text-emerald-800 border-emerald-200`,
  outlineRed: `bg-rose-100 text-rose-800 border border-rose-200`,
  outlineBlue: `bg-sky-100 text-sky-800 border border-sky-200`,
  outlineGray: `bg-gray-100 text-gray-700 border border-gray-200`,
} as const;

export interface PillProps extends React.HTMLAttributes<HTMLSpanElement> {
  color?: keyof typeof colorClasses;
  children: React.ReactNode;
}

export const Pill: React.FC<PillProps> = ({
  color = "blue",
  className = "",
  children,
  onClick,
  ...props
}) => {
  return (
    <span
      className={clsx(`whitespace-nowrap ${colorClasses[color]} ${className}`, {
        "inline-flex rounded-full border px-2 py-0.5 text-xs font-medium": color.startsWith("outline"),
        "rounded-full px-2 py-1": !color.startsWith("outline"),
        "cursor-pointer": !!onClick,
      })}
      onClick={onClick}
      {...props}
    >
      {children}
    </span>
  );
};
